import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';

export const useCampaignGroupBudgetDistributionEnabled = () =>
    useConfigMatch({ [FEATURE_FLAGS.CAMPAIGN_GROUP_BUDGET_DISTRIBUTION_ENABLED]: 'true' });
